import { render, staticRenderFns } from "./uniform-list.vue?vue&type=template&id=5e742789&scoped=true"
import script from "./uniform-list.vue?vue&type=script&lang=js"
export * from "./uniform-list.vue?vue&type=script&lang=js"
import style0 from "./uniform-list.vue?vue&type=style&index=0&id=5e742789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e742789",
  null
  
)

export default component.exports